import { useEffect, useState } from 'react';

/**
 * True once `ready` has held for `delayMs` and the browser is idle: used to start secondary requests (compose data)
 * only after what the user sees first (folders, first mail page) has loaded. Never flips back to false.
 */
export function useAfterIdle(ready: boolean, delayMs = 1000): boolean {
  const [done, setDone] = useState(false);
  useEffect(() => {
    if (!ready || done) return;
    let idle: number | undefined;
    const timer = window.setTimeout(() => {
      if (typeof window.requestIdleCallback === 'function') idle = window.requestIdleCallback(() => setDone(true), { timeout: 2000 });
      else setDone(true);
    }, delayMs);
    return () => {
      window.clearTimeout(timer);
      if (idle !== undefined) window.cancelIdleCallback(idle);
    };
  }, [ready, done, delayMs]);
  return done;
}
